import { workspaceModuleApi } from '../api';
import { useState } from 'react';
import { FetchStatus } from 'types/api';
import { isAxiosError } from 'axios';
import { QAItem } from 'types/api.d';

export const usePostQaDocument = () => {
  const [status, setPostStatus] = useState<FetchStatus>('idle');
  const [error, setError] = useState<string | null>(null);

  const postQaDocument = async (
    link: string,
    categoryId?: number,
    departmentId?: number
  ) => {
    try {
      setPostStatus('loading');
      const item = await workspaceModuleApi.addQaDocument(
        link,
        categoryId,
        departmentId
      );
      setPostStatus('success');
      return item;
    } catch (error) {
      if (isAxiosError(error)) {
        setError(error.response?.data.detail || error.message);
      } else {
        setError('An error occurred');
      }
      setPostStatus('failed');
    }
  };
  return { status, error, postQaDocument, setPostStatus };
};
